import { Component, ElementRef, inject, DestroyRef, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { EventOriginEnum } from '@app/core/enums/analytics/analytics-value.enum';
import { PermissionEnum } from '@app/core/enums/permissions.enum';
import { Project, ProjectInput } from '@app/core/model/entities/project/project';
import { Section } from '@app/core/model/other/field-config';
import { FormStateService } from '@app/shared/components/form-builder/form-state.service';
import { GeneratesObject } from '@app/shared/interfaces/generates-object';
import { SectionService } from '@services/section.service';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Component({
  templateUrl: './project-create-modal.component.html',
  styleUrls: ['../../../../../../../shared/components/fields/chips-field-builder/entity-chips-field-builder/entity-chips-field-builder.scss'],
  providers: [FormStateService],
  standalone: false
})
export class ProjectCreateModalComponent implements OnInit, GeneratesObject {
  public formId = 'project_creation_dialog';
  protected eventsOrigin = EventOriginEnum.SHEET;
  public Permission = PermissionEnum;
  public permissionsForEdition = [PermissionEnum.CREATE_PROJECT];
  protected missingRequiredFields$: Observable<{ code: string, label: string }[]>;
  protected form: Section[];

  protected projectInput: ProjectInput;

  @ViewChild('inputField') public inputField: ElementRef<HTMLInputElement>;
  @ViewChild('suggestions') public suggestions: MatAutocomplete;
  @ViewChild('trigger') public trigger: MatAutocompleteTrigger;

  protected readonly formStateService = inject(FormStateService);
  private readonly sectionService = inject(SectionService);
  protected readonly destroyRef = inject(DestroyRef);

  /**
   * Fetch accessible Assets.
   */
  public ngOnInit(): void {
    this.missingRequiredFields$ = this.sectionService.getSectionsByFormCode(this.formId).pipe(
      tap(sections => this.form = sections),
      map(sections => sections.first()),
      map(section => this.sectionService.missingRequiredFields(section)),
      takeUntilDestroyed(this.destroyRef)
    );

    this.formStateService.saved$
      .pipe(
        tap(({ data }) => {
          Project.transformPropertiesForInput(data);
          this.projectInput = data;
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  /**
   * Data from the filled form.
   * @return Project data.
   */
  public getGeneratedObject(): ProjectInput {
    return this.projectInput;
  }
}
